/* 🤖 this file was generated by svg-to-ts*/
export const icoMoon: {
  name: 'moon';
  data: string;
} = {
  name: 'moon',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.929 4.929c-3.905 3.905-3.905 10.237 0 14.142 3.905 3.905 10.237 3.905 14.142 0 1.271-1.271 2.449-3.21 2.892-4.803.249-.893-.746-1.614-1.517-1.1-2.903 1.932-6.893 1.799-9.153-.46-2.26-2.26-2.393-6.252-.46-9.154.513-.771-.208-1.766-1.101-1.517-1.594.443-3.531 1.62-4.803 2.892zm1.63 1.208c.37-.343.8-.677 1.254-.979l.108-.07-.014.047c-.948 3.168-.322 6.693 1.972 8.986l.188.183c2.224 2.077 5.502 2.674 8.507 1.87l.338-.096-.07.11a9.79 9.79 0 01-1.185 1.469A8 8 0 016.343 6.343l.215-.206z" fill="#909090"/></svg>`
};
